
import { defineComponent } from "vue";
import vtkRemoteView from "vtk.js/Sources/Rendering/Misc/RemoteView";
import { useSaveStateStore } from "@/stores/ssaStore/saveState";
import { storeToRefs } from "pinia";
export default defineComponent({
	name: "imdex-remote-render-view",
	setup() {
		const CANVAS = document.createElement("canvas");
		const { SSA_SAVING_STATE: savingState } = storeToRefs(useSaveStateStore());
		let SUBSCRIPTION = null as any;
		const unsubscribe = () => {
			if (SUBSCRIPTION) {
				SUBSCRIPTION.unsubscribe();
				SUBSCRIPTION = null;
			}
		};
		const imageToBlob = (image: any) => {
			return new Promise((resolve) => {
				CANVAS.width = image.width;
				CANVAS.height = image.height;
				const ctx: any = CANVAS.getContext("2d");
				ctx.drawImage(image, 0, 0);
				CANVAS.toBlob(resolve, "image/png");
			});
		};
		return {
			unsubscribe,
			imageToBlob,
			SUBSCRIPTION,
			savingState
		};
	},
	props: {
		viewId: {
			type: String,
			default: "-1"
		},
		client: {
			type: Object,
			default: null
		},
		active: {
			type: Boolean,
			default: false
		},
		activeColor: {
			type: String,
			default: "white"
		},
		activeSize: {
			type: Number,
			default: 1
		},
		defaultColor: {
			type: String,
			default: "black"
		},
		defaultSize: {
			type: Number,
			default: 1
		},
		pickingListener: {
			type: Function,
			default: Function.prototype
		},
		onClick: {
			type: Function,
			default: Function.prototype
		},
		enablePicking: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			connected: false,
			view: null as any,
			subscription: null as any
		};
	},
	created() {
		this.view = vtkRemoteView.newInstance({
			rpcWheelEvent: "viewport.mouse.zoom.wheel"
		});
		// default of 0.5 causes 2x size labels on high-DPI screens. 1 good for demo, not for production.

		// if (location.hostname.split(".")[0] === "localhost") { // removing the localhost check to see impact on production
		this.view.setInteractiveRatio(1); // this line fixes the 2x labels.  I think it will work fine for production.
		// }

		// Listen to mouse move for picking
		const style = this.view.getInteractorStyle();
		style.setSendMouseMove(this.enablePicking);
		this.subscription = style.onRemoteMouseEvent((e: any) => {
			this.pickingListener(e);
		});
		this.view.render();
	},
	mounted() {
		window.addEventListener("resize", this.view.resize);
		this.connect();
	},
	methods: {
		renderView() {
			this.view.render();
		},
		async connect() {
			if (this.client && this.client.getConnection()) {
				const session = this.client.getConnection().getSession();
				this.view.setSession(session);
				this.view.setViewId(this.viewId);
				this.view.setContainer(this.$el);
				this.connected = true;
				this.view.render();
			}
		},
		handleClick(event: any) {
			this.onClick(event);
		}
	},
	watch: {
		savingState(v) {
			if (!v) {
				this.view.render();
			}
		},
		client() {
			this.connect();
		},
		viewId(id) {
			if (this.connected) {
				this.view.setViewId(id);
				this.view.render();
			}
		},
		enablePicking(value) {
			this.view.getInteractorStyle().setSendMouseMove(value);
		}
	},
	beforeUnmount() {
		if (this.subscription) {
			this.subscription.unsubscribe();
			this.subscription = null;
		}
		window.removeEventListener("resize", this.view.resize);
		this.view.delete();
	}
});
